/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query MyQuery {
    PodcastRead {
      PodcastDescription
      podcastTitle
      horizontalPosterLink
      message
      id
      createdAt
      verticalPosterLink
      host
      guest
      directedBy
      producedBy
      status
      PodcastEpisode {
        audioLink
        episodeDescription
        episodeNumber
        id
        episodeTitle
      }
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
